module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 46
// module chunks = 0